import React from 'react';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { WidgetProps, DEFAULT_BUTTON_TEXT, SharedProps } from '../shared';
import { GetStartedButton } from '../GetStartedWidget/GetStartedButton';

export function GetStartedNoPhoneWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent,
  isScrolled = false
}: WidgetProps & SharedProps) {
  return (
    <GetStartedButton
      type="submit"
      cfButtonColor={buttonColor as CFColorTokenProp}
      cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
      isScrolled={isScrolled}
      aria-label="Get started"
      data-testid="get-started-button"
    >
      {buttonContent || buttonText}
    </GetStartedButton>
  );
}
